import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    fill="#2c3e43"
    style={{
      enableBackground: "new 0 0 17 15",
    }}
    viewBox="0 0 17 15"
    {...props}
  >
    <style>{".st0{fill-rule:evenodd;clip-rule:evenodd}"}</style>
    <path
      d="M3.9 14.8V4.9H.4v9.9h3.5zM2.2 3.6c1.2 0 2-.8 2-1.7C4.2.9 3.4.2 2.3.2S.3.9.3 1.9c-.1 1 .7 1.7 1.9 1.7zM6.1 14.8h3.5V9c0-.3 0-.6.1-.8.3-.6.8-1.3 1.8-1.3 1.3 0 1.8 1 1.8 2.4v5.6h3.5v-6c0-3.2-1.7-4.7-4-4.7-1.9 0-2.7 1-3.2 1.8V4.3H6.1v10.5z"
      className="st0"
    />
  </svg>
)
export default SvgComponent
